import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Helper function to prepare the date for display
export const prepareDisplayDate = (
  dateString: string | null | undefined,
): Date | undefined => {
  if (!dateString) {
    return undefined;
  }
  // dateString is "YYYY-MM-DD"
  const parts = dateString.split("-");
  if (parts.length !== 3) return undefined; // Basic validation

  const year = parseInt(parts[0], 10);
  const month = parseInt(parts[1], 10) - 1; // Month is 0-indexed for Date constructor
  const day = parseInt(parts[2], 10);

  if (isNaN(year) || isNaN(month) || isNaN(day)) return undefined; // More validation

  return new Date(year, month, day); // This creates a local midnight Date
};
